const normalizeContactValue = value => value?.toString().trim().toLowerCase() || "";

const getRateConfirmationContactOptions = contacts => {
  const contactIds = new Set();

  return (contacts || [])
    .filter(contact => {
      if (!contact?.id || !contact?.email || contactIds.has(contact.id)) {
        return false;
      }

      contactIds.add(contact.id);
      return true;
    })
    .map(contact => ({
      ...contact,
      recipientLabel: contact.name ? `${contact.name} (${contact.email})` : contact.email
    }));
};

const findRateConfirmationContactById = (contacts, contactId) =>
  (contacts || []).find(contact => contact.id === contactId);

const findRateConfirmationContact = (contacts, selectedContact = {}) => {
  const contactOptions = contacts || [];
  const contactId = selectedContact.contactId || selectedContact.id;
  const contactName = selectedContact.carrierContact || selectedContact.contactName || selectedContact.name;
  const contactEmail = selectedContact.contactEmail || selectedContact.carrierEmail || selectedContact.email;

  return findRateConfirmationContactById(contactOptions, contactId)
    || contactOptions.find(contact =>
      normalizeContactValue(contact.name) === normalizeContactValue(contactName)
      && normalizeContactValue(contact.email) === normalizeContactValue(contactEmail))
    || contactOptions.find(contact =>
      normalizeContactValue(contact.email) === normalizeContactValue(contactEmail))
    || contactOptions.find(contact =>
      normalizeContactValue(contact.name) === normalizeContactValue(contactName))
    || contactOptions[0];
};

export {
  findRateConfirmationContact,
  findRateConfirmationContactById,
  getRateConfirmationContactOptions
};
